import { useEffect, useState } from "react";
import AuthService from "../service/auth-service";

//登入狀態 hook
//
//  單一真相來源是 AuthService（localStorage + user-updated 事件）。
//  每個需要知道登入狀態的元件都自己讀 localStorage 再各自監聽事件，
//  會寫出好幾份一樣的 useEffect —— 收斂成這支。
//
//  回傳的 user 可能是 null（未登入）。
const useAuth = () => {
  const [user, setUser] = useState(() => AuthService.getUserProfile());

  useEffect(() => {
    //元件可能在登入之後才 mount，事件已經廣播過了 → 先同步一次目前值
    setUser(AuthService.getUserProfile());

    const onUserUpdated = (e) => setUser(e.detail);
    window.addEventListener("user-updated", onUserUpdated);
    return () => window.removeEventListener("user-updated", onUserUpdated);
  }, []);

  return { user, isLoggedIn: !!user };
};

export default useAuth;
